import update from 'immutability-helper';
import constants from 'constants';

const {
  ADD_SUBSCRIPTIONS
} = constants;

const subscriptions = (subscriptions = [], action) => {
  switch(action.type) {
    case ADD_SUBSCRIPTIONS:
      return update(subscriptions, {$push: action.subscriptions})
    default: return subscriptions;
  }
}

export { subscriptions };



// WEBPACK FOOTER //
// ./src/reducers/subscriptions.js